import React from "react";
import { Button } from "semantic-ui-react";
import arrowLeft from "../../../assets/icons/arrow-text-left.svg";

export default function BackButton({ action, ...props }) {
  return (
    <Button
      className={"overwrite-button icon-text-button not-print"}
      content={<span className={"action-text"}>Back</span>}
      icon={
        <img
          className={"icon-text-button-img"}
          src={arrowLeft}
          style={{ width: 14, height: 12 }}
          alt="arrow left logo"
        />
      }
      onClick={action}
      {...props}
    />
  );
}
